import { useCallback, useState } from 'react';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { APPS_PHONE_QUERY, BUILDER_COMPACT_QUERY } from '../../apps.constants';
import { BUILDER_PANE_APP, BUILDER_PANE_CHAT, type BuilderPane } from './builderWorkspace.constants';

export const useBuilderLayout = () => {
  const isPhone = useMediaQuery(APPS_PHONE_QUERY);
  const compact = useMediaQuery(BUILDER_COMPACT_QUERY);
  const [railOpen, setRailOpen] = useState(() => !compact);
  const [chatOpen, setChatOpen] = useState(true);
  const [phonePane, setPhonePane] = useState<BuilderPane>(BUILDER_PANE_APP);

  const toggleRail = useCallback(() => setRailOpen((open) => !open), []);
  const toggleChat = useCallback(() => setChatOpen((open) => !open), []);
  const showChat = useCallback(() => {
    setPhonePane(BUILDER_PANE_CHAT);
    setChatOpen(true);
  }, []);
  const focusApp = useCallback(() => {
    setRailOpen(false);
    setChatOpen(false);
    setPhonePane(BUILDER_PANE_APP);
  }, []);
  const chatVisible = isPhone ? phonePane === BUILDER_PANE_CHAT : chatOpen;

  return { isPhone, railOpen, toggleRail, chatOpen, toggleChat, chatVisible, phonePane, setPhonePane, showChat, focusApp };
};

export type BuilderLayoutState = ReturnType<typeof useBuilderLayout>;
